import type { SVGComponentProps } from 'BreetHelpers';

export const RemoveTeamMemberIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='80'
		height='80'
		viewBox='0 0 80 80'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M38.2363 62.7403C38.2363 66.9003 39.5156 70.7668 41.7058 73.9678C39.1588 74.432 36.5332 74.6736 33.8519 74.6736C22.5765 74.6736 12.2983 70.3967 4.55566 63.3751V63.3502C4.55566 51.672 11.3892 41.5914 21.2742 36.8867C24.9892 40.5921 29.3391 42.5887 33.8519 42.5887C38.3667 42.5887 42.7146 40.5921 46.4316 36.8867C49.646 38.4172 52.5382 40.5154 54.974 43.0528C45.4956 44.591 38.2363 52.8342 38.2363 62.7403Z'
			fill='#2FB1CA'
		/>
		<path
			d='M33.852 0C42.801 0 50.0565 7.25358 50.0565 16.2026C50.0565 25.1536 42.801 37.3937 33.852 37.3937C24.903 37.3937 17.6475 25.1536 17.6475 16.2026C17.6475 7.25358 24.903 0 33.852 0Z'
			fill='#CDECF2'
		/>
		<path
			d='M58.1832 79.9992C67.7163 79.9992 75.4445 72.271 75.4445 62.7379C75.4445 53.2047 67.7163 45.4766 58.1832 45.4766C48.65 45.4766 40.9219 53.2047 40.9219 62.7379C40.9219 72.271 48.65 79.9992 58.1832 79.9992Z'
			fill='#DF3939'
		/>
		<path
			d='M70.1178 61.3008H46.249V64.1777H70.1178V61.3008Z'
			fill='white'
		/>
	</svg>
);
